import { render, staticRenderFns } from "./BemFinanceiro.vue?vue&type=template&id=e8796c40"
import script from "./BemFinanceiro.vue?vue&type=script&lang=js"
export * from "./BemFinanceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports